import {useEffect} from 'react';
import {useSearchParams} from '../../../router/compat';

/**
 * ACC-506: When the top-nav "Create → Ticket" item navigates to
 * `/tickets?create=1`, open the ticket-creation modal once on arrival, then
 * strip the param (replace, so back-nav / refresh don't re-open it). Fails
 * closed: if the user lacks create permission the param is still cleaned up but
 * the modal stays shut (the gateway also enforces TICKETS_CREATE).
 */
export function useOpenCreateFromQuery(canCreate: boolean, openCreateModal: () => void): void {
	const [searchParams, setSearchParams] = useSearchParams();
	const hasCreateParam = searchParams.get('create') === '1';

	useEffect(() => {
		if (!hasCreateParam) return;
		if (canCreate) openCreateModal();
		setSearchParams(
			prev => {
				const updated = new URLSearchParams(prev);
				updated.delete('create');
				return updated;
			},
			{replace: true}
		);
		// Run once per arrival with the param present. openCreateModal is stable
		// (a setState updater); excluded to avoid re-firing on parent re-render.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [hasCreateParam, canCreate, setSearchParams]);
}
